import { isDirectOnlyAdministrator } from '../Utils/NotificationPreferences'

export const shouldReceiveProgramMessage = (user, event, notificationMode) => {
  if (!user?._id || user._id === event?.userId) return false

  const isDirectRecipient = event?.toUserIds?.includes(user._id)

  if (isDirectOnlyAdministrator(user, notificationMode)) {
    return Boolean(isDirectRecipient)
  }

  return Boolean(
    isDirectRecipient || event?.toRoles?.includes(user?.role)
  )
}
